<script>
import macarons from "@/common/theme.json";
import cloneDeep from "lodash/cloneDeep";
import sortBy from "lodash/sortBy";
import moment from "moment";

export default {
  props: {
    StatisticsResult: Array,
    chartTitle: String,
    chartYTitle: String,
    seriesNameY: String,
    yType: String,
    width: String
  },
  data() {
    const copyResultData = cloneDeep(this.StatisticsResult);
    return {
      copyResultData,
      visionChallengeChart: {},
      type: this.yType,
      chartWidth: this.width || "500px"
    };
  },
  mounted() {
    this.$nextTick(function() {
      this.drawLine();
    });
    window.addEventListener("resize", this.resize);
  },

  destroyed() {
    window.removeEventListener("resize", this.resize);
  },
  methods: {
    drawLine() {
      let weekCounts = 12;
      let intervaltest = undefined;
      this.$echarts.registerTheme("myMacarons", macarons);
      const chartComponent = this.$refs[this.yType];

      let myChart = this.$echarts.init(chartComponent, "myMacarons");
      let getX = this.copyResultData.map((o, index) =>
        moment(o.createdAt).format("YYYY-MM-DD HH:mm:ss")
      );
      const getValueY = this.copyResultData.map((o, index) => [
        moment(o.createdAt).format("YYYY-MM-DD HH:mm:ss"),
        o.value
      ]);
      myChart.setOption({
        title: {
          text: this.chartTitle,
          textStyle: {
            color: "#0A0A0A",
            fontWeight: "normal"
          }
        },
        tooltip: {
          trigger: "axis",
          formatter: params => {
            var result = `${params[0].data[0]} <br/>`;
            params.map(item => {
              result += `${item.seriesName} : ${
                isNaN(item.value[1]) ? "-" : item.value[1]
              } </br>`;
            });
            return result;
          }
        },
        grid: {
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "time",
            splitLine: { show: false },
            boundaryGap: false,
            data: getX.map(function(item) {
              return item;
            }),
            axisLabel: {
              textStyle: {
                color: "rgba(0,0,0,0.65)"
              }
            }
          }
        ],
        yAxis: {
          type: "value",
          name: this.chartYTitle 
        },
        series: [
          {
            name: this.seriesNameY || this.chartYTitle,
            type: "line",
            data: getValueY,
            connectNulls: true,
            itemStyle: {
              normal: {
                color: "#00C1DE",
                lineStyle: {
                  color: "#00C1DE"
                }
              }
            }
          }
        ]
      });
      this.visionChallengeChart = myChart;
    },
    resize: function() {
      this.visionChallengeChart.resize();
    }
  }
};
</script>
<template>
  <div :ref="yType" :style="{width: chartWidth, height: '350px'}"></div>
</template>


// WEBPACK FOOTER //
// src/components/visionStatistics/basicLineChart.vue